const state = {
    isNewsletterSubscribeVisible: false
};

const getters = {
    isNewsletterSubscribeVisible: state => state.isNewsletterSubscribeVisible
};

const mutations = {
    setNewsletterSubscribeVisible: (state, data) => state.isNewsletterSubscribeVisible = data
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
};